export const USER_DETAILS = 'userDetails';
export const SET_LANGUAGE = 'currentLang';
export const ARTICLES_LIST = 'articlesList'
export const PROJECTS_LIST = 'projectList'
export const SET_LOCATION_BOOK = 'locationByBook'